import {css} from '@emotion/react'

export const cardStyle = () => css`
  &:hover {
    .background {
      box-shadow: var(--chakra-shadows-xl);
    }
  }
`
